

export class CustomizeToolTipListOutput implements ICustomizeToolTipListOutput {
    /** The auto-generated id of the customize tool tip master */
    customize_tooltip_id!: number;
    /** The user group name with 255 character limit */
    customize_tooltip_name!: string;
    /** Manage status of customize tool tip. 0 For De-active, 1 For Active */
    status!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The auto-generated creating time of tbl_customize_tooltip_option item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_customize_tooltip_option item add or update */
    updating_date!: any;

    constructor(data?: ICustomizeToolTipListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customize_tooltip_id = _data["customize_tooltip_id"];
            this.customize_tooltip_name = _data["customize_tooltip_name"];
            this.status = _data["status"];
            this.company_name = _data["company_name"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
        }
    }

    static fromJS(data: any): CustomizeToolTipListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customize_tooltip_id"] = this.customize_tooltip_id;
        data["customize_tooltip_name"] = this.customize_tooltip_name;
        data["status"] = this.status;
        data["company_name"] = this.company_name;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        return data; 
    }
}

export interface ICustomizeToolTipListOutput {
    /** The auto-generated id of the customize tool tip master */
    customize_tooltip_id: number;
    /** The user group name with 255 character limit */
    customize_tooltip_name: string;
    /** Manage status of customize tool tip. 0 For De-active, 1 For Active */
    status: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The auto-generated creating time of tbl_customize_tooltip_option item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_customize_tooltip_option item add or update */
    updating_date: any;
}

